import { jsNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/notification-v2.0.0'

export default jsNode(
	'notification',
	{
		'v2.0.0': v200,
	},
	{ color: 'purple' }
)
